module.exports = __webpack_public_path__ + "static/media/torus.ede75e2b.svg";